import { defineMessages } from 'react-intl';

const messages: {
	approvals: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	downIcon: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	home: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	more: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	portals: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	requests: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	downIcon: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.down-icon',
		defaultMessage: 'Open dropdown',
		description: 'Icon label for the chevron down icon',
	},
	home: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.home.non-final',
		defaultMessage: 'Home',
		description: 'Navigation link label for the home page',
	},
	more: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.more.non-final',
		defaultMessage: 'More',
		description: 'Navigation link label for the more page',
	},
	portals: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.portals.non-final',
		defaultMessage: 'Portals',
		description: 'Navigation link label for the portals page',
	},
	requests: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.requests.non-final',
		defaultMessage: 'Requests',
		description: 'Navigation link label for user requests',
	},
	approvals: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.approvals.non-final',
		defaultMessage: 'Approvals',
		description: 'Navigation link label for user approvals',
	},
});

export default messages;
